import apiClient from "utils/apiClient";

const API_BASE = "/identity-service/api/v1";

const unwrap = (response) => response.data;

const withPaging = (params = {}) => {
  const { page = 0, size = 20, ...rest } = params;
  return { page, size, ...rest };
};

export const identitySubscriptionService = {
  plans: {
    list: async (params = {}) =>
      apiClient
        .get(`${API_BASE}/subscription-plans`, { params: withPaging(params) })
        .then(unwrap),

    get: async (planId, params = {}) =>
      apiClient
        .get(`${API_BASE}/subscription-plans/${planId}`, { params })
        .then(unwrap),

    create: async (data) =>
      apiClient.post(`${API_BASE}/subscription-plans`, data).then(unwrap),

    update: async (planId, data) =>
      apiClient.patch(`${API_BASE}/subscription-plans/${planId}`, data).then(unwrap),

    delete: async (planId) =>
      apiClient.delete(`${API_BASE}/subscription-plans/${planId}`).then(unwrap),
  },

  subscriptions: {
    list: async (params = {}) =>
      apiClient
        .get(`${API_BASE}/subscriptions`, { params: withPaging(params) })
        .then(unwrap),

    get: async (subscriptionId, params = {}) =>
      apiClient
        .get(`${API_BASE}/subscriptions/${subscriptionId}`, { params })
        .then(unwrap),

    listByPlan: async (planId, params = {}) =>
      apiClient
        .get(`${API_BASE}/subscriptions/plan/${planId}`, { params: withPaging(params) })
        .then(unwrap),

    create: async (data) =>
      apiClient.post(`${API_BASE}/subscriptions`, data).then(unwrap),

    update: async (subscriptionId, data) =>
      apiClient.patch(`${API_BASE}/subscriptions/${subscriptionId}`, data).then(unwrap),

    cancel: async (subscriptionId) =>
      apiClient.post(`${API_BASE}/subscriptions/${subscriptionId}/cancel`).then(unwrap),
  },
};

export default identitySubscriptionService;
